// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout wrapper for proper footer positioning */
.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden; /* Prevent horizontal scroll */
}

.dashboard-with-sidebar {
  display: flex;
  flex: 1 1; /* Take remaining space */
  background-color: #f5f6fa;
  padding-top: 0; /* No padding needed since sidebar goes full height */
  position: relative; /* Ensure proper positioning context */
}

.dashboard-sidebar {
  width: var(--sidebar-width, 260px);
  background-color: #ffffff;
  border-right: 1px solid #e1e4e8;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0; /* Extend to bottom */
  overflow-y: auto;
  transition: all 0.3s ease;
  z-index: 50; /* Lower z-index, doesn't need to be so high */
}

.sidebar-logo {
  padding: 20px;
  background: #4D64C1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  border-bottom: none;
  margin-bottom: 0;
  border-right: none;
}

.sidebar-logo img {
  max-height: 60px;
  width: auto;
  display: block;
}

.sidebar-logo-text {
  color: #4D64C1;
  font-size: 32px;
  font-weight: 700;
  text-decoration: none;
  margin: 0;
  letter-spacing: -1px;
}

.dashboard-sidebar.collapsed {
  width: 70px;
}

.sidebar-section {
  padding: 20px 10px;
  border-bottom: 1px solid #e1e4e8;
}

.sidebar-section-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #95a5a6;
  margin-bottom: 10px;
  letter-spacing: 1px;
  padding-left: 12px;
}

.sidebar-nav {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-nav-item {
  margin-bottom: 4px;
}

.sidebar-nav-link {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin: 4px 8px;
  color: #495057;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  border: 1px solid transparent;
}

.sidebar-nav-link:hover {
  background-color: #f0f3ff;
  color: #4D64C1;
  border-color: #4D64C1;
  transform: translateX(4px);
  text-decoration: none;
}

.sidebar-nav-link.active {
  background-color: #4D64C1;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(77, 100, 193, 0.3);
}

.sidebar-nav-link.active:hover {
  background-color: #3d52a0;
  color: #ffffff;
  border-color: transparent;
}

.sidebar-nav-link i {
  width: 24px;
  margin-right: 12px;
  font-size: 18px;
  text-align: center;
  opacity: 0.8;
}

.sidebar-nav-link:hover i {
  opacity: 1;
}

.sidebar-nav-link.active i {
  opacity: 1;
}

.sidebar-nav-link .badge {
  margin-left: auto;
  font-size: 11px;
  padding: 4px 10px;
  font-weight: 600;
  border-radius: 12px;
}

.sidebar-nav-link.new-order {
  background: linear-gradient(135deg, #5a67d8 0%, #4c51bf 100%);
  color: white;
  font-weight: 600;
  border: 1px solid rgba(255,255,255,0.2);
  margin: 8px;
}

.sidebar-nav-link.new-order:hover {
  background: linear-gradient(135deg, #4c51bf 0%, #5a67d8 100%);
  transform: translateX(4px);
  box-shadow: 0 4px 15px rgba(90, 103, 216, 0.4);
  color: white;
  border-color: rgba(255,255,255,0.3);
}

.dashboard-main-content {
  flex: 1 1;
  padding: 30px;
  padding-top: 120px; /* Account for fixed 100px top bar + 20px spacing */
  overflow-x: hidden;
  margin-left: var(--sidebar-visible, 0px);
  width: calc(100% - var(--sidebar-visible, 0px));
  min-height: calc(100vh - 100px); /* Minimum height to push footer down */
  box-sizing: border-box; /* Ensure padding is included in width */
  transition: margin-left 0.3s ease, width 0.3s ease;
}

.dashboard-main-content.sidebar-collapsed {
  margin-left: 70px;
  width: calc(100% - 70px);
}

/* Dashboard page specific adjustments */
.dashboard-main-content.dashboard-page {
  margin-left: var(--sidebar-visible, 0px);
  /* No need for separate padding-top, using the default from .dashboard-main-content */
}

/* Container adjustments - let Layout.tsx handle responsive behavior */
.dashboard-main-content .container-fluid {
  max-width: 100%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

/* Row layout */
.dashboard-main-content .row {
  display: flex;
  flex-wrap: wrap;
}

/* Order detail page layout - responsive defaults */
.order-detail-container {
  width: 100%;
}

.order-detail-container .row {
  display: flex !important;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.order-detail-container .order-items-section,
.order-detail-container .order-info-section {
  padding: 0 15px;
  position: relative;
}

/* Override Bootstrap's default col classes */
@media (min-width: 992px) {
  .order-detail-container .order-items-section {
    flex: 0 0 66.66667% !important;
    max-width: 66.66667% !important;
  }
  
  .order-detail-container .order-info-section {
    flex: 0 0 33.33333% !important;
    max-width: 33.33333% !important;
  }
  
  .order-detail-container .row {
    flex-wrap: nowrap !important;
  }
}

@media (max-width: 991px) {
  .order-detail-container .order-items-section,
  .order-detail-container .order-info-section {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

/* Quick Stats Cards */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.stat-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.stat-card-title {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.stat-card-value {
  font-size: 28px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 5px;
}

.stat-card-change {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-card-change.positive {
  color: #28a745;
}

.stat-card-change.negative {
  color: #dc3545;
}

/* Order Options Grid */
.order-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.order-option-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 2px solid transparent;
}

.order-option-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border-color: #4D64C1;
  text-decoration: none;
  color: inherit;
}

.order-option-card.featured {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.order-option-card.featured:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
}

.order-option-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 15px;
  background-color: rgba(77, 100, 193, 0.1);
  color: #4D64C1;
}

.order-option-card.featured .order-option-icon {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.order-option-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.order-option-description {
  font-size: 13px;
  color: #6c757d;
  margin: 0;
}

.order-option-card.featured .order-option-description {
  color: rgba(255, 255, 255, 0.9);
}

/* Welcome Header */
.dashboard-welcome {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  border-radius: 12px;
  padding: 40px;
  margin-bottom: 30px;
  margin-top: 0; /* Ensure no extra top margin */
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.dashboard-welcome h1 {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
}

.dashboard-welcome p {
  font-size: 16px;
  opacity: 0.85;
  margin: 0;
  font-weight: 400;
}

.start-shopping-btn {
  background: linear-gradient(135deg, #4D64C1 0%, #3d52a0 100%);
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.start-shopping-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(77, 100, 193, 0.4);
  background: linear-gradient(135deg, #3d52a0 0%, #4D64C1 100%);
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-sidebar {
    transform: translateX(-100%);
  }
  
  .dashboard-sidebar.mobile-open {
    transform: translateX(0);
  }
  
  .dashboard-main-content {
    margin-left: 0;
    width: 100%;
    padding: 20px;
    padding-top: 120px; /* Account for fixed 100px top bar + 20px spacing */
    min-height: calc(100vh - 100px); /* Minimum height to match top bar height */
  }
  
  .unified-top-bar {
    padding-left: 15px !important;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .order-options-grid {
    grid-template-columns: 1fr;
  }
}

/* Sidebar Toggle Button */
.sidebar-toggle {
  display: none;
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1050;
  background: #4D64C1;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(77, 100, 193, 0.4);
  cursor: pointer;
}

@media (max-width: 768px) {
  .sidebar-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* Footer Styles */
.portal-footer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 35px 0 20px;
  width: 100%;
  position: relative; /* Normal document flow */
  z-index: 100; /* Above sidebar */
  margin-left: 0; /* Full width, no margin */
  margin-top: auto; /* Push to bottom when content is short */
  font-size: 14px; /* Slightly smaller base font */
}

.portal-footer h5 {
  color: white;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
}

.portal-footer a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

.portal-footer a:hover {
  color: white;
  text-decoration: underline;
}

.footer-links-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links-list li {
  margin-bottom: 6px;
  line-height: 1.4;
}

/* Ensure footer content stays compact */
.portal-footer .small {
  font-size: 13px;
}

.portal-footer address {
  font-style: normal;
  line-height: 1.5;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 30px;
  padding-top: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
}

/* Footer responsive adjustments - use standard Bootstrap breakpoints */

@media (min-width: 992px) and (max-width: 1199px) {
  /* Compact mode for large screens */
  .portal-footer {
    font-size: 13px;
  }
  
  .portal-footer h5 {
    font-size: 15px;
  }
  
  .portal-footer .small {
    font-size: 12px;
  }
}

@media (max-width: 991px) {
  .portal-footer {
    padding: 30px 0 15px;
  }
  
  .portal-footer h5 {
    margin-bottom: 10px;
  }
}

/* Social Icons */
.social-icons {
  margin-top: 10px;
}

.social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transition: background-color 0.3s;
  margin-right: 10px;
}

.social-icon:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.social-icon i {
  font-size: 16px;
  color: white;
}

/* Approval Queue Badge */
.approval-badge {
  background-color: #dc3545;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,aAAa;EACb,SAAO,EAAE,yBAAyB;EAClC,yBAAyB;EACzB,cAAc,EAAE,qDAAqD;EACrE,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,+BAA+B;EAC/B,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS,EAAE,qBAAqB;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,WAAW,EAAE,8CAA8C;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,8CAA8C;EAC9C,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB,EAAE,mDAAmD;EACvE,kBAAkB;EAClB,wCAAwC;EACxC,+CAA+C;EAC/C,+BAA+B,EAAE,uCAAuC;EACxE,sBAAsB,EAAE,wCAAwC;EAChE,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,wCAAwC;EACxC,qFAAqF;AACvF;;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa,EAAE,+BAA+B;EAC9C,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA,sBAAsB;AACtB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,kBAAkB,EAAE,mDAAmD;IACvE,+BAA+B,EAAE,2CAA2C;EAC9E;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,kBAAkB,EAAE,yBAAyB;EAC7C,YAAY,EAAE,kBAAkB;EAChC,cAAc,EAAE,0BAA0B;EAC1C,gBAAgB,EAAE,yCAAyC;EAC3D,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,uEAAuE;;AAEvE;EACE,mCAAmC;EACnC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":["/* Layout wrapper for proper footer positioning */\n.layout-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  overflow-x: hidden; /* Prevent horizontal scroll */\n}\n\n.dashboard-with-sidebar {\n  display: flex;\n  flex: 1; /* Take remaining space */\n  background-color: #f5f6fa;\n  padding-top: 0; /* No padding needed since sidebar goes full height */\n  position: relative; /* Ensure proper positioning context */\n}\n\n.dashboard-sidebar {\n  width: var(--sidebar-width, 260px);\n  background-color: #ffffff;\n  border-right: 1px solid #e1e4e8;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0; /* Extend to bottom */\n  overflow-y: auto;\n  transition: all 0.3s ease;\n  z-index: 50; /* Lower z-index, doesn't need to be so high */\n}\n\n.sidebar-logo {\n  padding: 20px;\n  background: #4D64C1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80px;\n  border-bottom: none;\n  margin-bottom: 0;\n  border-right: none;\n}\n\n.sidebar-logo img {\n  max-height: 60px;\n  width: auto;\n  display: block;\n}\n\n.sidebar-logo-text {\n  color: #4D64C1;\n  font-size: 32px;\n  font-weight: 700;\n  text-decoration: none;\n  margin: 0;\n  letter-spacing: -1px;\n}\n\n.dashboard-sidebar.collapsed {\n  width: 70px;\n}\n\n.sidebar-section {\n  padding: 20px 10px;\n  border-bottom: 1px solid #e1e4e8;\n}\n\n.sidebar-section-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #95a5a6;\n  margin-bottom: 10px;\n  letter-spacing: 1px;\n  padding-left: 12px;\n}\n\n.sidebar-nav {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-nav-item {\n  margin-bottom: 4px;\n}\n\n.sidebar-nav-link {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  margin: 4px 8px;\n  color: #495057;\n  text-decoration: none;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  font-weight: 500;\n  position: relative;\n  border: 1px solid transparent;\n}\n\n.sidebar-nav-link:hover {\n  background-color: #f0f3ff;\n  color: #4D64C1;\n  border-color: #4D64C1;\n  transform: translateX(4px);\n  text-decoration: none;\n}\n\n.sidebar-nav-link.active {\n  background-color: #4D64C1;\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(77, 100, 193, 0.3);\n}\n\n.sidebar-nav-link.active:hover {\n  background-color: #3d52a0;\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.sidebar-nav-link i {\n  width: 24px;\n  margin-right: 12px;\n  font-size: 18px;\n  text-align: center;\n  opacity: 0.8;\n}\n\n.sidebar-nav-link:hover i {\n  opacity: 1;\n}\n\n.sidebar-nav-link.active i {\n  opacity: 1;\n}\n\n.sidebar-nav-link .badge {\n  margin-left: auto;\n  font-size: 11px;\n  padding: 4px 10px;\n  font-weight: 600;\n  border-radius: 12px;\n}\n\n.sidebar-nav-link.new-order {\n  background: linear-gradient(135deg, #5a67d8 0%, #4c51bf 100%);\n  color: white;\n  font-weight: 600;\n  border: 1px solid rgba(255,255,255,0.2);\n  margin: 8px;\n}\n\n.sidebar-nav-link.new-order:hover {\n  background: linear-gradient(135deg, #4c51bf 0%, #5a67d8 100%);\n  transform: translateX(4px);\n  box-shadow: 0 4px 15px rgba(90, 103, 216, 0.4);\n  color: white;\n  border-color: rgba(255,255,255,0.3);\n}\n\n.dashboard-main-content {\n  flex: 1;\n  padding: 30px;\n  padding-top: 120px; /* Account for fixed 100px top bar + 20px spacing */\n  overflow-x: hidden;\n  margin-left: var(--sidebar-visible, 0px);\n  width: calc(100% - var(--sidebar-visible, 0px));\n  min-height: calc(100vh - 100px); /* Minimum height to push footer down */\n  box-sizing: border-box; /* Ensure padding is included in width */\n  transition: margin-left 0.3s ease, width 0.3s ease;\n}\n\n.dashboard-main-content.sidebar-collapsed {\n  margin-left: 70px;\n  width: calc(100% - 70px);\n}\n\n/* Dashboard page specific adjustments */\n.dashboard-main-content.dashboard-page {\n  margin-left: var(--sidebar-visible, 0px);\n  /* No need for separate padding-top, using the default from .dashboard-main-content */\n}\n\n/* Container adjustments - let Layout.tsx handle responsive behavior */\n.dashboard-main-content .container-fluid {\n  max-width: 100%;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n/* Row layout */\n.dashboard-main-content .row {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n/* Order detail page layout - responsive defaults */\n.order-detail-container {\n  width: 100%;\n}\n\n.order-detail-container .row {\n  display: flex !important;\n  flex-wrap: wrap;\n  margin: 0 -15px;\n}\n\n.order-detail-container .order-items-section,\n.order-detail-container .order-info-section {\n  padding: 0 15px;\n  position: relative;\n}\n\n/* Override Bootstrap's default col classes */\n@media (min-width: 992px) {\n  .order-detail-container .order-items-section {\n    flex: 0 0 66.66667% !important;\n    max-width: 66.66667% !important;\n  }\n  \n  .order-detail-container .order-info-section {\n    flex: 0 0 33.33333% !important;\n    max-width: 33.33333% !important;\n  }\n  \n  .order-detail-container .row {\n    flex-wrap: nowrap !important;\n  }\n}\n\n@media (max-width: 991px) {\n  .order-detail-container .order-items-section,\n  .order-detail-container .order-info-section {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n/* Quick Stats Cards */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.stat-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 10px;\n}\n\n.stat-card-title {\n  font-size: 13px;\n  color: #6c757d;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-card-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.stat-card-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #212529;\n  margin-bottom: 5px;\n}\n\n.stat-card-change {\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.stat-card-change.positive {\n  color: #28a745;\n}\n\n.stat-card-change.negative {\n  color: #dc3545;\n}\n\n/* Order Options Grid */\n.order-options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.order-option-card {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 25px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  border: 2px solid transparent;\n}\n\n.order-option-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n  border-color: #4D64C1;\n  text-decoration: none;\n  color: inherit;\n}\n\n.order-option-card.featured {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.order-option-card.featured:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);\n}\n\n.order-option-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin-bottom: 15px;\n  background-color: rgba(77, 100, 193, 0.1);\n  color: #4D64C1;\n}\n\n.order-option-card.featured .order-option-icon {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.order-option-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.order-option-description {\n  font-size: 13px;\n  color: #6c757d;\n  margin: 0;\n}\n\n.order-option-card.featured .order-option-description {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Welcome Header */\n.dashboard-welcome {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  border-radius: 12px;\n  padding: 40px;\n  margin-bottom: 30px;\n  margin-top: 0; /* Ensure no extra top margin */\n  color: white;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-welcome h1 {\n  font-size: 32px;\n  font-weight: 300;\n  margin-bottom: 10px;\n  letter-spacing: -0.5px;\n}\n\n.dashboard-welcome p {\n  font-size: 16px;\n  opacity: 0.85;\n  margin: 0;\n  font-weight: 400;\n}\n\n.start-shopping-btn {\n  background: linear-gradient(135deg, #4D64C1 0%, #3d52a0 100%);\n  color: white;\n  border: none;\n  padding: 12px 28px;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.start-shopping-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(77, 100, 193, 0.4);\n  background: linear-gradient(135deg, #3d52a0 0%, #4D64C1 100%);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-sidebar {\n    transform: translateX(-100%);\n  }\n  \n  .dashboard-sidebar.mobile-open {\n    transform: translateX(0);\n  }\n  \n  .dashboard-main-content {\n    margin-left: 0;\n    width: 100%;\n    padding: 20px;\n    padding-top: 120px; /* Account for fixed 100px top bar + 20px spacing */\n    min-height: calc(100vh - 100px); /* Minimum height to match top bar height */\n  }\n  \n  .unified-top-bar {\n    padding-left: 15px !important;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .order-options-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Sidebar Toggle Button */\n.sidebar-toggle {\n  display: none;\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  z-index: 1050;\n  background: #4D64C1;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  font-size: 20px;\n  box-shadow: 0 4px 12px rgba(77, 100, 193, 0.4);\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .sidebar-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* Footer Styles */\n.portal-footer {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  color: white;\n  padding: 35px 0 20px;\n  width: 100%;\n  position: relative; /* Normal document flow */\n  z-index: 100; /* Above sidebar */\n  margin-left: 0; /* Full width, no margin */\n  margin-top: auto; /* Push to bottom when content is short */\n  font-size: 14px; /* Slightly smaller base font */\n}\n\n.portal-footer h5 {\n  color: white;\n  margin-bottom: 12px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.portal-footer a {\n  color: rgba(255, 255, 255, 0.8);\n  text-decoration: none;\n}\n\n.portal-footer a:hover {\n  color: white;\n  text-decoration: underline;\n}\n\n.footer-links-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-links-list li {\n  margin-bottom: 6px;\n  line-height: 1.4;\n}\n\n/* Ensure footer content stays compact */\n.portal-footer .small {\n  font-size: 13px;\n}\n\n.portal-footer address {\n  font-style: normal;\n  line-height: 1.5;\n}\n\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin-top: 30px;\n  padding-top: 20px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Footer responsive adjustments - use standard Bootstrap breakpoints */\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  /* Compact mode for large screens */\n  .portal-footer {\n    font-size: 13px;\n  }\n  \n  .portal-footer h5 {\n    font-size: 15px;\n  }\n  \n  .portal-footer .small {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 991px) {\n  .portal-footer {\n    padding: 30px 0 15px;\n  }\n  \n  .portal-footer h5 {\n    margin-bottom: 10px;\n  }\n}\n\n/* Social Icons */\n.social-icons {\n  margin-top: 10px;\n}\n\n.social-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  transition: background-color 0.3s;\n  margin-right: 10px;\n}\n\n.social-icon:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.social-icon i {\n  font-size: 16px;\n  color: white;\n}\n\n/* Approval Queue Badge */\n.approval-badge {\n  background-color: #dc3545;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: bold;\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
